const getSlas = async (skus) => {
  try {
    const query = skus
      .map((sku) => `sku[]=${encodeURIComponent(sku)}`)
      .join('&');
    const response = await fetch(`${process.env.SLA_API_URL}?${query}`, {
      method: 'GET',
    });
    if (response.ok) {
      return response.json();
    }
    return undefined;
  } catch (error) {
    return undefined;
  }
};

const slaService = {
  getSlas,
};

export default slaService;
